import { Box,Stack,Tab,Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import ChecklistStyle from "./ChecklistStyle";
import PrintTemplate from "./PrintTemplate";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function PrintTemplateTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState<number>(0);
  function handleChange(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  };

  return (
    <Stack width='100%' alignItems='flex-start' justifyContent='flex-start'>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab label={t('checklists.printConfig.title')} value={0} />
        <Tab label={'Visual Checklist Web'} value={1} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <PrintTemplate />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ChecklistStyle />
      </CustomTabPanel>
    </Stack>
  );
}

export default PrintTemplateTabs;